<template>
  <div :class="['toolbar-button', isH5 ? 'toolbar-button-h5' : '', isClicked ? 'end-conversation-button-clicked' : '']" @click="onClick">
    <Icon v-if="props.icon" class="toolbar-button-icon" :file="props.icon" width="14px" height="14px"/>
    <div class="toolbar-button-text">
      {{ props.title || TUITranslateService.t('AIDesk.结束会话') }}
    </div>
  </div>
</template>
<script lang="ts" setup>
import vue from '../../../adapter-vue';
const { ref, onMounted, onUnmounted } = vue;
import { isH5 } from '../../../utils/env';
import Icon from '../../common/Icon.vue';
import { TUITranslateService, TUIChatService, IConversationModel, TUIStore, StoreName } from '../../../@aidesk/uikit-engine';
import { CUSTOM_MESSAGE_SRC } from '../../../constant';
import { isEnabledMessageReadReceiptGlobal, getTo } from '../../../utils/utils';
const currentConversation = ref<IConversationModel>();
const isClicked = ref(false);
interface IProps {
  title?:string;
  icon?:string | undefined;
}

const props = withDefaults(defineProps<IProps>(), {
  title: '',
  icon: ''
})

const emits = defineEmits(['closePopover']);

onMounted(() => {
  TUIStore.watch(StoreName.CONV, {
    currentConversation: onCurrentConversationUpdate,
  });
});

onUnmounted(() => {
  TUIStore.unwatch(StoreName.CONV, {
    currentConversation: onCurrentConversationUpdate,
  });
});

const onCurrentConversationUpdate = (conversation: IConversationModel) => {
  currentConversation.value = conversation;
};

const onClick = () => {
  if (isClicked.value || !currentConversation.value) {
    return;
  }
  isClicked.value = true;
  TUIChatService.sendCustomMessage({
    to: getTo(currentConversation.value),
    conversationType: currentConversation.value.type,
    payload: {
      data: JSON.stringify({
        customerServicePlugin: 0,
        src: CUSTOM_MESSAGE_SRC.USER_END_CONVERSATION,
      }),
    },
    needReadReceipt: isEnabledMessageReadReceiptGlobal(),
  },{ onlineUserOnly:true })
  .finally(() => {
    emits('closePopover');
  });
}

</script>
<style>
.end-conversation-button-clicked {
  background: #f0f2f9;
  color: #97A3B4;
  cursor: default;
}
</style>
